<template>
  <TabbedBox :useQueryNavigation="true">
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-pricereport">
        <i class="far fa-tag"></i> Customer Pricing Report
      </Tab>
      <Tab tabid="tab-priceoverridereport">
        <i class="fas fa-tag"></i> Price List Overrides Report
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-pricereport">
        <CustomerPricingReport />
      </TabPage>

      <TabPage tabid="tab-priceoverridereport">
        <PriceListReport />
      </TabPage>
    </template>
  </TabbedBox>
</template>


<script>
import CustomerPricingReport from './customerPricingReport'
import PriceListReport from './priceListReport'

export default {
  name: 'CustomerPricing',
  components: {
    CustomerPricingReport,
    PriceListReport
  },
  data() {
    return {
    }
  }
}
</script>
